module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.89889688.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 1050
// module chunks = 0